import { render, staticRenderFns } from "./upload-attachment.vue?vue&type=template&id=0878dc34&"
import script from "./upload-attachment.vue?vue&type=script&lang=js&"
export * from "./upload-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports